module.exports = __webpack_public_path__ + "assets/img/timeLine_img7.f5f4ac7a.png";